import { TileCoordinates } from "../../../lib/runescape/coordinates";
import { Vector2 } from "../../../lib/math";
export class ClueIndex {
    constructor(data) {
        this.data = data;
    }
    get(id) {
        return this.data[id];
    }
    filtered() {
        return this.data.filter(c => !!c);
    }
    static simple(base_data) {
        let data = Array(Math.max(...base_data.map(c => c.id)));
        base_data.forEach(c => {
            data[c.id] = { clue: c };
        });
        return new ClueIndex(data);
    }
    with(init) {
        return new ClueIndex(this.data.map(v => {
            return v ? { ...v, ...init() } : null;
        }));
    }
}
export class ClueSpotIndex {
    constructor(_index) {
        this._index = _index;
    }
    static simple(base) {
        return new ClueSpotIndex(base.data.map(v => {
            let c = {
                clue: v.clue,
                value: { for: { clue: v.clue } },
                spot_index: v.clue.type == "compass"
                    ? []
                    : undefined
            };
            if (v.clue.type == "compass") {
                c.spot_index = new Array(ClueSpotIndex.BUCKETS);
                for (let i = 0; i < c.spot_index.length; i++) {
                    c.spot_index[i] = [];
                }
                v.clue.spots.forEach(s => {
                    let hash = Vector2.hash(s, ClueSpotIndex.BUCKETS);
                    c.spot_index[hash].push({
                        spot: s,
                        value: { for: { clue: v.clue, spot: s } }
                    });
                });
            }
            return c;
        }));
    }
    with(init) {
        return new ClueSpotIndex(this._index.map(v => {
            return {
                clue: v.clue,
                value: { ...v.value, ...init() },
                spot_index: v.spot_index
                    ? v.spot_index.map(bucket => bucket.map(v => {
                        return {
                            spot: v.spot,
                            value: { ...v.value, ...init() }
                        };
                    }))
                    : undefined
            };
        }));
    }
    get(clue, fallback_if_no_spot_index = true) {
        const r = this._index[clue.clue];
        if (!r)
            return null;
        if (!clue.spot && !r.spot_index)
            return r.value;
        if (clue.spot && r.spot_index) {
            const bucket = r.spot_index[Vector2.hash(clue.spot, ClueSpotIndex.BUCKETS)];
            return bucket.find(v => TileCoordinates.eq2(v.spot, clue.spot))?.value ?? (fallback_if_no_spot_index ? r.value : null);
        }
        return (fallback_if_no_spot_index ? r.value : null);
    }
    flat() {
        let acc = [];
        this.forEach(e => acc.push(e));
        return acc;
    }
    forEach(f) {
        this._index.forEach(e => {
            if (e) {
                if (e.spot_index)
                    e.spot_index.forEach(bucket => {
                        bucket.forEach(e => f(e.value));
                    });
                else {
                    f(e.value);
                }
            }
        });
    }
}
ClueSpotIndex.BUCKETS = 64;
